import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export interface Actions {
  type: string;
  value: any;
}

export interface StateContext {
  [key: string]: any;
}

export const StateContext = React.createContext({} as StateContext);
export const DispatchContext = React.createContext({} as Dispatch<Actions>);

export const useContextState: any = (selector: any = undefined) => {
  const defaultSelector = (state: any) => state;
  return useSelector(selector || defaultSelector);
};
export const useContextDispatch: any = () => useDispatch();
